export const SET_LISTNAME = 'SET_LISTNAME';
export const SET_LISTDESCRIPTION = 'SET_LISTDESCRIPTION';
export const SET_LISTITEMS = 'SET_LISTITEMS';
export const SET_LISTISACTIVE = 'SET_ISACTIVE';
export const SET_LISTID = 'SET_ID';